
document.addEventListener('DOMContentLoaded', () => {
  const popup = document.getElementById('InstagramPopup');
  if (popup) {
    const popupDismissed = localStorage.getItem('makorean_instagram_popup_dismissed');
    if (!popupDismissed) {
      setTimeout(() => {
        popup.hidden = false;
        document.body.classList.add('overflow-hidden');
      }, 1200);
    }
    popup.querySelectorAll('[data-close-instagram-popup]').forEach((el) => {
      el.addEventListener('click', () => {
        popup.hidden = true;
        document.body.classList.remove('overflow-hidden');
        localStorage.setItem('makorean_instagram_popup_dismissed', 'true');
      });
    });
  }
});
window.addEventListener('cart:updated', async function () {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();

    const cartCount = document.querySelector('.site-header__cart-count');

    if (cart.item_count > 0) {
      if (cartCount) {
        cartCount.textContent = cart.item_count;
      } else {
        const cartIcon = document.querySelector('.site-header__cart');
        if (cartIcon) {
          const badge = document.createElement('span');
          badge.className = 'site-header__cart-count';
          badge.textContent = cart.item_count;
          cartIcon.appendChild(badge);
        }
      }
    } else if (cartCount) {
      cartCount.remove();
    }
  } catch (e) {
    console.error('No se pudo actualizar el contador del carrito', e);
  }
});